var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ height: _vm.opts.height + 'px', width: _vm.opts.width + 'px' })},[_c('polygon',{attrs:{"fill":_vm.pColor,"points":_vm.polygonPoints}}),_c('polyline',{attrs:{"fill":"none","points":_vm.polylinePoints,"stroke":_vm.sColor,"stroke-width":_vm.opts.strokeWidth,"stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }